import { render, staticRenderFns } from "./AddRequestStatus.vue?vue&type=template&id=627e1ffc&scoped=true"
import script from "./AddRequestStatus.vue?vue&type=script&lang=js"
export * from "./AddRequestStatus.vue?vue&type=script&lang=js"
import style0 from "./AddRequestStatus.vue?vue&type=style&index=0&id=627e1ffc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "627e1ffc",
  null
  
)

export default component.exports